export default __webpack_public_path__ + "static/media/cenarioGrafo.c63ad7ec.png";